__webpack_require__.p = "/course-authoring/";